<div class="filters">
  <h4>
    <span class="filter-toggle" (click)="showFilters = !showFilters">
      <i
        class="icon angle"
        [ngClass]="{ up: !showFilters, down: showFilters }"
      ></i>

      Filters
    </span>

    @if (notices?.length) {
    <span class="viewing"
      >(Viewing {{ notices?.length }} notice{{
        notices?.length === 1 ? "" : "s"
      }})</span
    >
    } @if (!loading) {
    <i
      class="ui icon redo alternate refresh-search"
      (click)="clearSelectedNoticeAndSearch()"
    ></i>
    }
    <span class="ui inline tiny loader" [ngClass]="{ active: loading }"></span>
    @if (getSelectedNotices().length) {
    <button
      class="mini ui button primary reprocess"
      (click)="reprocessNotices.emit(getSelectedNotices())"
    >
      Reprocess {{ getSelectedNotices().length }} notice{{
        getSelectedNotices().length == 1 ? "" : "s"
      }}
    </button>
    }
  </h4>

  @if (showFilters) {
  <div class="filters-container">
    <label>
      <span class="filter-label">State</span>
      <select
        class="state"
        (input)="filterExceptionsChanged($event.target.value)"
        [value]="filters.exceptions"
      >
        <option value="Any">Show all</option>
        <option value="Yes">Only exceptions</option>
        <option value="No">Only non-exceptions</option>
      </select>
    </label>
    <label>
      <span class="filter-label">Step</span>
      <select
        (input)="filterStepChanged($event.target.value)"
        [value]="filters.step"
      >
        <option value="Any">Show All</option>
        @for (step of steps; track step) {
        <option
          value="{{ step.id }}"
          [selected]="filters.step == step.id.toString()"
          >{{ step.name(config) }}</option
        >
        }
      </select>
    </label>
    <label>
      <span class="filter-label">NoticeType</span>
      <select
        (input)="filterNoticeTypeChanged($event.target.value)"
        [value]="filters.noticeType"
      >
        <option value="Any">Show All</option>
        @for (noticeType of noticeTypes; track noticeType) {
        <option
          value="{{ noticeType.id }}"
          [selected]="filters.noticeType == noticeType.id.toString()"
          >{{ noticeType.name }}</option
        >
        }
      </select>
    </label>
    <label>
      <span class="filter-label">Owner / Assigned To</span>
      <select
        (input)="filterUserChanged($event.target.value)"
        [value]="filters.user"
      >
        <option value="Any">Show All</option>
        <option value="Unassigned">Unassigned</option>
        @for (user of users; track user) {
        <option
          value="{{ user.id }}"
          [selected]="filters.user == user.id.toString()"
          >{{ makeName(user) }}</option
        >
        }
      </select>
    </label>
    <label>
      <span class="filter-label">AtlasId</span>
      <input
        type="number"
        (input)="filterAtlasIdChanged($event.target.value)"
        [value]="filters.atlasId"
      />
    </label>
    <label>
      <span class="filter-label">Name</span>
      <input
        type="text"
        (input)="filterNameChanged($event.target.value)"
        [value]="filters.name"
      />
    </label>
    <label>
      <span class="filter-label">Date received</span>
      <input
        type="text"
        placeholder="yyyy-mm-dd"
        [(ngModel)]="filters.receiveDate"
        (keyup.enter)="filterReceiveDateChanged()"
      />
    </label>
    <label>
      <span class="filter-label">Year</span>
      <select
        (ngModelChange)="filterYearChanged($event)"
        [(ngModel)]="filters.year"
      >
        <option value="">Show All</option>
        @for (year of noticeYears; track year) {
        <option value="{{ year }}">{{ year }}</option>
        }
      </select>
    </label>
    <label>
      <span class="filter-label">Client</span>
      <select
        (ngModelChange)="filterClientChanged($event)"
        [(ngModel)]="filters.clientId"
      >
        <option value="">Show All</option>
        @for (client of clientList; track client) {
        <option value="{{ client.id }}">{{ client.name }}</option>
        }
      </select>
    </label>
    <label>
      <span class="filter-label">Notice Type Group</span>
      <select
        (ngModelChange)="filterNoticeTypeGroupChanged($event)"
        [(ngModel)]="filters.noticeTypeGroup"
      >
        <option value="">Show All</option>
        @for (group of noticeTypeGroupList; track group) {
        <option value="{{ group.value }}">{{ group.label }}</option>
        }
      </select>
    </label>
  </div>
  }
</div>

<div class="table-header">
  <div class="row">
    <div class="checkbox"></div>
    <div class="notice-id">
      ID
    </div>
    <div class="taxpayer-name">
      Taxpayer
    </div>
    <div class="year">
      Year
    </div>
    <div class="notice-type">
      Notice Type
    </div>
    <div class="due-date">
      Due Date
    </div>
    <div class="step">
      Step
    </div>
    <div class="issue">
      Issue
    </div>
    <div class="amount">
      Amount
    </div>
    <div class="owner">
      Owner
    </div>
    <div class="assigned-to">
      Assigned To
    </div>
  </div>
</div>

<div
  class="table-body hidden-scrollbar"
  [ngClass]="{ loading: loading, 'not-empty': notices?.length > 0 }"
>
  @for (n of notices; track noticeTrackBy($index, n)) {
  <div
    class="row"
    [ngClass]="{ selected: n.id === selectedNotice?.id }"
    (click)="noticeSelected.emit(n)"
  >
    <div class="checkbox" (click)="$event.stopPropagation()">
      <input
        type="checkbox"
        [checked]="!!n.checkboxSelected"
        (input)="setNoticeCheckboxSelected(n, $event.target.checked)"
      />
    </div>
    <div class="notice-id">
      {{ n.id }}
    </div>
    <div class="taxpayer-name">
      {{ n.taxpayerName }}
    </div>
    <div class="year">
      {{ n.periodStr }}
    </div>
    <div class="notice-type">
      {{ n.noticeType?.displayName || n.noticeType?.name }}
    </div>
    <div class="due-date">
      {{ n.dueDateStr }}
    </div>
    <div class="step">
      {{ n.step.name }}
    </div>
    <div class="issue">
      <div [innerHtml]="n.issueStr"></div>
    </div>
    <div class="amount">
      {{ getAmountStr(n.amount) }}
    </div>
    <div
      class="owner"
      (mouseenter)="n.ownerHovered = true"
      (mouseleave)="n.ownerHovered = false"
    >
      @if (n.ownerHovered) {
      <select
        [value]="(getOwner(n)?.id || '').toString()"
        (input)="ownerChanged(n, $event.target.value)"
        (click)="$event.stopPropagation()"
      >
        <option value="">Unassigned</option>
        @for (user of users; track user) {
        <option [value]="user.id">{{ makeName(user) }}</option>
        }
      </select>
      }
      <span class="name">{{ getOwnerName(n) }}</span>
      @if (!!pendingOwnerUpdates[n.id]) {
      <span class="ui inline mini loader active"></span>
      }
    </div>
    <div
      class="assigned-to"
      (mouseenter)="n.assignedToHovered = true"
      (mouseleave)="n.assignedToHovered = false"
    >
      @if (n.assignedToHovered) {
      <select
        [value]="(getAssignee(n)?.id || '').toString()"
        (input)="assigneeChanged(n, $event.target.value)"
        (click)="$event.stopPropagation()"
      >
        <option value="">Unassigned</option>
        @for (user of users; track user) {
        <option [value]="user.id">{{ makeName(user) }}</option>
        }
      </select>
      }
      <span class="name">{{ getAssigneeName(n) }}</span>
      @if (!!pendingAssigneeUpdates[n.id]) {
      <span class="ui inline mini loader active"></span>
      }
    </div>
  </div>
  }
</div>

@if (notices && notices.length == 0) {
<div class="no-results">No documents found for the current search filter</div>
}
